module.exports = __webpack_public_path__ + "static/media/qqqun.7bf7eb8c.png";